import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  provinces: {
    data: [],
    meta: {
      total: 0,
    },
  },

  zones: {
    data: [],
    meta: {
      total: 0,
    },
  },

  countries: {
    data: [],
    meta: {
      total: 0,
    },
  },

  days: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the provinces
export const fetchProvinces = createAsyncThunk(
  "fetchProvinces/provinces",
  async ({ enqueueSnackbar, limit = 100, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`assets/provinces`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: fetch all the days
export const fetchDays = createAsyncThunk(
  "fetchDays/days",
  async ({ enqueueSnackbar, limit = 10, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`assets/days`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: fetch all the zones
export const fetchZones = createAsyncThunk(
  "fetchZones/zones",
  async ({ enqueueSnackbar, limit = 100, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`assets/zones`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: fetch all the countries
export const fetchCountries = createAsyncThunk(
  "fetchCountries/countries",
  async ({ enqueueSnackbar, limit = 200, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`assets/countries`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const placeSlice = createSlice({
  name: "place",
  initialState,
  extraReducers: (builder) => {
    // TODO: fetch province
    builder.addCase(fetchProvinces.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchProvinces.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.provinces = action.payload;
    });

    builder.addCase(fetchProvinces.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: fetch day
    builder.addCase(fetchDays.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchDays.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.days = action.payload;
    });

    builder.addCase(fetchDays.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: fetch zone
    builder.addCase(fetchZones.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchZones.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.zones = action.payload;
    });

    builder.addCase(fetchZones.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: fetch countries
    builder.addCase(fetchCountries.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchCountries.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.countries = action.payload;
    });

    builder.addCase(fetchCountries.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default placeSlice.reducer;
